if (!customElements.get("quick-view-modal")) {
    customElements.define(
      "quick-view-modal",
      class QuickViewModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector("#QuickViewModal");

          this.addEventListener("product-info:loaded", ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });
        }

        hide(preventFocus = false) {
          const cartNotification = document.querySelector("cart-drawer");
          if (cartNotification)
            cartNotification.setActiveElement(this.openedBy);
          setTimeout(() => (this.modalContent.innerHTML = ""), 500);

          if (preventFocus) this.openedBy = null;
          super.hide();
        }

        show(opener) {
          opener.setAttribute("aria-disabled", true);
          opener.classList.add("loading");
          opener.querySelector(".loading__spinner").classList.remove("hidden");

          fetch(opener.getAttribute("data-product-url").split("?")[0])
            .then((response) => response.text())
            .then((responseText) => {
              const responseHTML = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const productElement = responseHTML.querySelector("product-info");

              this.preprocessHTML(productElement);
              HTMLUpdateUtility.setInnerHTML(
                this.modalContent,
                productElement.outerHTML
              );

              if (typeof window.initProductSubtotals === "function") {
                window.initProductSubtotals(this.modalContent);
              }

              // Ensure CompareColor component is defined when content is injected
              if (typeof window.compareColor === 'undefined' && !customElements.get('compare-color')) {
                try { window.compareColor(); } catch (e) { /* no-op */ }
              }

              if (window.Shopify && Shopify.PaymentButton)
                Shopify.PaymentButton.init();
              if (window.ProductModel) window.ProductModel.loadShopifyXR();

              super.show(opener);
            })
            .finally(() => {
              opener.removeAttribute("aria-disabled");
              opener.classList.remove("loading");
              opener.querySelector(".loading__spinner").classList.add("hidden");
            });
        }

        preprocessHTML(productElement) {
          productElement.classList.forEach((classApplied) => {
            if (
              classApplied.startsWith("color-") ||
              classApplied === "gradient"
            )
              this.modalContent.classList.add(classApplied);
          });
          this.preventDuplicatedIDs(productElement);
          this.removeDOMElements(productElement);
          this.removeGalleryListSemantic(productElement);
          this.preventVariantURLSwitching(productElement);
          this.qvThumbsBottom(productElement);
        }

        // GF: live (Ella 6) quick view shows the thumbnails in a row under the main image
        qvThumbsBottom(productElement) {
          productElement.querySelectorAll('swiper-component[data-thumbnail-direction="vertical"]').forEach((el) => el.setAttribute("data-thumbnail-direction", "horizontal"));
          // GF: live's main image takes the height of the current slide (natural aspect)
          productElement.querySelectorAll("media-gallery swiper-component").forEach((el) => { el.setAttribute("data-auto-height", "true"); el.setAttribute("data-gf-no-ro", "true"); });
          productElement.querySelectorAll('[data-thumbnail-position="left"], [data-thumbnail-position="right"]').forEach((el) => {
            el.setAttribute("data-thumbnail-position", "bottom");
            if (el.hasAttribute("data-thumbnail-direction")) el.setAttribute("data-thumbnail-direction", "horizontal");
          });
          const thumbs = productElement.querySelector(".swiper-controls__thumbnails-container");
          if (thumbs) {
            // GF: live shows 3 thumbs (4 at >=1600px), 15px apart, with its own prev/next arrows
            thumbs.setAttribute("data-thumbs-per-view", "3");
            thumbs.setAttribute("data-thumbs-per-view-wide", "4");
            thumbs.setAttribute("data-thumbs-gap", "15");
            // a looping thumbs strip fights the main slider's loop when stepping with the arrows; keep only the main slider looping
            thumbs.querySelectorAll(".swiper[data-loop]").forEach((el) => el.removeAttribute("data-loop"));
            if (thumbs.querySelectorAll(".swiper-slide").length > 1 && !thumbs.querySelector(".gf-qv-thumb-arrow")) {
              const svg = '<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg>';
              thumbs.insertAdjacentHTML("beforeend", '<button type="button" class="gf-qv-thumb-arrow gf-qv-thumb-arrow--prev" aria-label="Previous">' + svg + '</button><button type="button" class="gf-qv-thumb-arrow gf-qv-thumb-arrow--next" aria-label="Next">' + svg + '</button>');
            }
          }
          // GF: live shows the "sold in last" line under the title
          const sold = productElement.querySelector("sold-in-last-component");
          const titleBlock = productElement.querySelector(".group-block-content h1")?.closest(".text-block");
          if (sold && titleBlock) titleBlock.after(sold);
        }

        preventVariantURLSwitching(productElement) {
          productElement.setAttribute("data-update-url", "false");
        }

        removeDOMElements(productElement) {
          const pickupAvailability = productElement.querySelector(
            "pickup-availability"
          );
          if (pickupAvailability) pickupAvailability.remove();

          const shareButton = productElement.querySelector("share-button");
          if (shareButton) shareButton.remove();

          const productModal = productElement.querySelector("product-modal");
          if (productModal) productModal.remove();

          const modalDialog = productElement.querySelectorAll("modal-dialog");
          if (modalDialog) modalDialog.forEach((modal) => modal.remove());

          const sideDrawerOpener = productElement.querySelectorAll(
            "side-drawer-opener:not(.agree-condition-popup-modal__opener--keep)"
          );
          if (sideDrawerOpener)
            sideDrawerOpener.forEach((button) => button.remove());

          const sideDrawer = productElement.querySelectorAll(
            "side-drawer:not(.agree-condition-popup-modal__drawer--keep)"
          );
          if (sideDrawer) sideDrawer.forEach((drawer) => drawer.remove());
        }

        preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;

          const oldId = sectionId;
          const newId = `quickview-${sectionId}`;

          productElement.innerHTML = productElement.innerHTML.replaceAll(
            oldId,
            newId
          );
          Array.from(productElement.attributes).forEach((attribute) => {
            if (attribute.value.includes(oldId)) {
              productElement.setAttribute(
                attribute.name,
                attribute.value.replace(oldId, newId)
              );
            }
          });

          productElement.dataset.originalSection = sectionId;
        }

        removeGalleryListSemantic(productElement) {
          const galleryList = productElement.querySelector(
            '[id^="Slider-Gallery"]'
          );
          if (!galleryList) return;

          galleryList.setAttribute("role", "presentation");
          galleryList
            .querySelectorAll('[id^="Slide-"]')
            .forEach((li) => li.setAttribute("role", "presentation"));
        }
      }
    );
}

// GF: quick view thumbnail arrows step the main image (like live's slick nav arrows)
if (!window.gfQvThumbArrows) {
  window.gfQvThumbArrows = true;
  document.addEventListener("click", (e) => {
    const btn = e.target.closest && e.target.closest(".gf-qv-thumb-arrow");
    if (!btn) return;
    e.preventDefault();
    const sw = btn.closest("swiper-component")?.initSwiper;
    if (!sw) return;
    const next = btn.classList.contains("gf-qv-thumb-arrow--next");
    // step by real index and wrap (live's slick nav is infinite); slideToLoop keeps the thumbs sync stable
    const count = sw.params.loop ? new Set([...sw.slides].map((el) => el.getAttribute("data-swiper-slide-index"))).size : sw.slides.length;
    const cur = sw.params.loop ? sw.realIndex : sw.activeIndex;
    const target = (cur + (next ? 1 : -1) + count) % count;
    sw.params.loop ? sw.slideToLoop(target) : sw.slideTo(target);
  });
}
